<div class="spinner-container" *ngIf="calculandoImporte">
  <ngx-spinner name="spinnerImporteFactura" bdOpacity=0.3bd
    Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
    <p style="color: white">Calculando importe de factura...</p>
  </ngx-spinner>
</div>

<form *ngIf="!calculandoImporte">

  <div class="modal-header bg-light">
    <h4 class="modal-title">Facturar Aerovale de contado</h4>

    <button type="button" class="btn-close" aria-label="Close" (click)="this.activeModal.close()">
      
    </button>
  </div>

  <div class="modal-body" [formGroup]="importeFacturaForm">

    <div class="row">
      <div class="mb-3 row col-md-12" style="color: red" *ngIf="this.mostrarMensajeFacturacionEnPruebas">
          Atención: Este valor no indica el importe a cobrar al cliente.
      </div>
    </div>

    <div class="row">
      <div class="mb-3 row col-md-12">
        <label for="importeFormControl" class="col-sm-5 col-form-label">Importe a facturar</label>
        <div class="col-sm-3">
          {{ this.facturaRespuesta?.total | number: '0.2'}}
        </div>
      </div>
    </div>

    <div style="padding: 1em; border: 1px solid #ccc;">     
      <div class="d-grid gap-2 col-6 mx-auto">
        <button (click)="this.modalAgregarCupon(TipoPago.Indeterminado)" type="button" class="btn btn-primary"> TARJETA DE CREDITO/DEBITO</button>

        <button [disabled]="inProduction && !configuracionPagosElectronicos" (click)="this.modalAgregarCupon(TipoPago.MercadoPago)" type="button" class="btn btn-primary"> MERCADO PAGO</button>
        <div *ngIf="inProduction && !configuracionPagosElectronicos" class="letra-error">
          Aviso: Los pagos con MERCADO PAGO no están disponibles.
        </div>

        <button [disabled]="(inProduction && !configuracionPagosElectronicos) || deshabilitarPagosConAppYpf" data-bs-toggle="tooltip" data-bs-placement="right" title="{{tooltipAppYpf}}" (click)="this.modalAgregarCupon(TipoPago.AppYpf)" type="button" class="btn btn-primary"> APP YPF</button>
        <div *ngIf="deshabilitarPagosConAppYpf" class="letra-error">
          Aviso: Los pagos APP YPF están disponibles únicamente para Consumidores Finales.
        </div>
        
        <div *ngIf="inProduction && !configuracionPagosElectronicos" class="letra-error">
          Aviso: Los pagos con APP YPF no están disponibles.
        </div>

        <button [disabled]="deshabilitarPagoConPointSmart" data-bs-toggle="tooltip" data-bs-placement="right" title="{{tooltipPointSmart}}" (click)="this.modalAgregarCupon(TipoPago.Point)" type="button" class="btn btn-primary"> POINT SMART</button>
        <div *ngIf="deshabilitarPagoConPointSmart" class="letra-error">
          Aviso: La Aeroplanta no posee dispositivos Point Smart configurados.
        </div>
      </div>
    </div>

    <div style="padding: 1em; border: 1px solid #ccc;">

      <div class="row">
        <div class="mb-3 row col-12">
          <div class="col-12"><b>Medios de Pago:</b></div>
        </div>
      </div>

      <div *ngIf="this.emitirFactura != null && this.emitirFactura.cupones.length > 0" class="row">
        <div class="mb-3 row col-md-12" *ngFor="let c of this.emitirFactura.cupones">
          <div class="col-sm-10">Tarjeta: <b>{{c.tarjeta.nombre}} &nbsp; {{c.numeroTarjeta}}</b> - Cupón: <b>{{c.numeroLote}}/{{c.numeroCupon}}</b>  -  <b>${{c.importe | number: '0.2-2'}}</b></div>
          <div class="col-sm-2"><button type="button" (click)="desasignarCupon(c)"
              class="btn btn-danger btn-sm col-sm-12"><i class="fa fa-trash col-sm-12" aria-hidden="true"></i></button>
          </div>
        </div>
      </div>

      <div *ngIf="this.emitirFactura != null && this.emitirFactura._payment?.length > 0" class="row">
        <div class="mb-3 row col-md-12 align-items-center" *ngFor="let p of this.emitirFactura._payment">
          <div class="col-sm-10">Tipo: <b>{{ this.getTipoPago(p.tipoPago) }} &nbsp; </b>
            {{ p.tipoPago == TipoPago.Point ? ' - Referencia: ' : ' - Nº de operación: '}}  <b>{{ p.tipoPago == TipoPago.Point ? p._alias + ' - Nº: ' + p._numero : this.getNumeroOperacion(p.paymentId) }}</b>  -  <b>${{p.importe | number: '0.2-2'}}</b>
          </div>
          <div class="col-sm-2" style="text-align: center;">
            <!--<img style="height: 40px; width: 50px;" id="logo-ypf" [src]="getPagoImage(p.tipoPago)" />-->
          </div>
        </div>
      </div>
    </div>

    <loading-text-spinner 
      *ngIf="this.mensaje!=null" message={{this.mensaje}}
      orientation="vertical" class="list-group-item mt-2" size="large" color="primary" textColor="dark">
    </loading-text-spinner>

    <div style="padding: 1em; border: 1px solid #ccc; margin-top: 0.5em;">

      <div class="row">
        <div class="mb-3 row col-md-12">
          <label  class="col-sm-5 col-form-label">Total de cupones:</label>
          <div class="col-sm-3">
            {{ this.totalPagoTarjeta | number: '0.2'}}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="mb-3 row col-md-12">
          <label  class="col-sm-5 col-form-label">Total de pagos electrónicos:</label>
          <div class="col-sm-3">
            {{ this.totalPagoEectronico | number: '0.2'}}
          </div>
        </div>
      </div>
      @if (paymentInDiscount) {
        <div class="row">
          <div class="mb-3 row col-md-12">
            <label  class="col-sm-5 col-form-label">Descuento APP YPF:</label>
            <div class="col-sm-3">
              {{ this.totalDescuentoPagoEletronico | number: '0.2'}}
            </div>
          </div>
        </div>
      }
      <div class="row">
        <div class="mb-3 row col-md-12">
          <label class="col-sm-5 col-form-label">Total efectivo:</label>
          <div class="col-sm-3">
            {{ this.getTotalEfectivo() | number: '0.2'}}
          </div>
        </div>
      </div>

      <!--COMENTARIO-->
      <div class="row">
        <div class="mb-3 row col-md-12">
          <label class="col-sm-5 col-form-label">Comentarios:</label>
          <div class="col-sm-7">
            <textarea class="form-control" formControlName="comentariosFormControl" rows='5'></textarea>
          </div>
        </div>
      </div>

    </div>

    <div class="alert alert-danger" *ngIf="error != null">
      {{error}}
    </div>

  </div>

  <div class="modal-footer bg-light">
      
    <button (click)="facturar()" class="btn btn-primary" [disabled]="this.facturando" type="submit">
      <span *ngIf="!this.facturando">Facturar</span>
      <div *ngIf="this.facturando" class="d-flex align-items-center">
        <div class="spinner-border text-light spinner-border-sm" role="status"></div>
        <span>Facturando...</span>
      </div>
    </button>
  
    <button [disabled]="paymentInSuccess" type="button" class="btn btn-secondary" (click)="onClose()">Cancelar</button>

    <div style="color: red" *ngIf="mostrarEsperaEntreReintentosFacturacion">
      Fallo la conexión con AFIP. Aguarde mientras reintentamos conectarnos.
      <br/>
      <b>Reintentaremos conexión en {{this.segundosRestantes}} segundos.</b>
    </div>
  </div>


</form>
